import { PlusSquare, Upload } from "react-feather";
import { Form, Input } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { AddUploadMediaProps } from "../../../../Types/FileManagerType";

const AddUploadMedia:React.FC<AddUploadMediaProps> = ({ onFileChange, onFileUpload }) => {
  const getFile = () => {
    const fileInput = document.getElementById("UpFile") as HTMLInputElement | null;
    if (fileInput) fileInput.click();
  };
  return (
    <div className="flex-grow-1 text-end">
      <Form className="d-inline-flex">
        <Btn color="primary" className="plus-square" onClick={getFile}>
          <PlusSquare /> {"Add New"}
        </Btn>
        <div style={{ height: "0px", width: "0px", overflow: "hidden" }}>
          <Input id="UpFile" multiple type="file" onChange={(event) => onFileChange(event)} />
        </div>
      </Form>
      <Btn color="secondary" className="ms-2" onClick={onFileUpload}>
        <Upload /> {"Upload"}
      </Btn>
    </div>
  );
};
export default AddUploadMedia;
